<template>
  <router-view></router-view>
</template>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

body {
  background-color: #1e1a20;
}
::-webkit-scrollbar {
  display: none;
}
</style>
